import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import {
  Container,
  Typography
} from '@material-ui/core';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';
import { setAlert } from '../../../../redux/actions/alertActions';

// Components
import BadgeForm from '../../../../components/BadgeForm';

// Constants
import { DEFAULT } from '../../../../constants';

class AssignBadge extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectToBadges: false
    };
  }

  render() {
    return this.state.redirectToBadges || !this.props.setupMode ? <Redirect to='/admin/badges' /> : (
      <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant='h1'>Badge Assignment</Typography>
        <BadgeForm onSuccess={() => this.setState({ redirectToBadges: true })} />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  statusColor: state.status.schoolStatus ? state.status.schoolStatus.getColor() : DEFAULT,
  isMobile: state.ui.isMobile,
  isFullWidth: state.ui.isFullWidth,
  setupMode: state.setupMode.mode || state.setupMode.isLoading
});

const mapDispatchToProps = dispatch => ({
  setError: (msg) => setAlert(dispatch, msg)
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignBadge);

AssignBadge.propTypes = {
  setError: PropTypes.func,
  setSuccess: PropTypes.func,
  isMobile: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  statusColor: PropTypes.object,
  setupMode: PropTypes.bool.isRequired
};
